const adjectives = [
    { en:"Bright", ko:"밝은" },
    { en:"Clear", ko:"맑은" },
    { en:"Fair", ko:"고운" },
    { en:"Kind", ko:"다정한" },
    { en:"Quiet", ko:"조용한" },
    { en:"Warm", ko:"따뜻한" },
    { en:"Fresh", ko:"산뜻한" },
    { en:"Cozy", ko:"포근한" },
    { en:"Soft", ko:"은은한" },
    { en:"Calm", ko:"잔잔한" },

    { en:"Still", ko:"차분한" },
    { en:"Glad", ko:"기쁜" },
    { en:"Joyful", ko:"즐거운" },
    { en:"Fun", ko:"신나는" },
    { en:"Happy", ko:"행복한" },
    { en:"Sweet", ko:"상냥한" },
    { en:"Kind", ko:"친절한" },
    { en:"Cheer", ko:"명랑한" },
    { en:"Jolly", ko:"유쾌한" },
    { en:"Nice", ko:"기분좋은" },

    { en:"Smooth", ko:"부드러운" },
    { en:"Peace", ko:"평화로운" },
    { en:"Green", ko:"싱그러운" },
    { en:"Cool", ko:"상쾌한" },
    { en:"Clean", ko:"깨끗한" },
    { en:"Spark", ko:"반짝이는" },
    { en:"Shiny", ko:"빛나는" },
    { en:"Dazzle", ko:"눈부신" },
    { en:"Clear", ko:"선명한" },

    { en:"Grace", ko:"우아한" },
    { en:"Style", ko:"세련된" },
    { en:"Cool", ko:"멋진" },
    { en:"Proud", ko:"기특한" },
    { en:"Thrill", ko:"설레는" },
    { en:"Hope", ko:"희망찬" },
    { en:"Ener", ko:"활기찬" },
    { en:"Passion", ko:"열정적인" },
    { en:"Brave", ko:"용감한" },
    { en:"Bold", ko:"대담한" },

    { en:"Sure", ko:"당당한" },
    { en:"Pluck", ko:"씩씩한" },
    { en:"True", ko:"성실한" },
    { en:"Hardy", ko:"부지런한" },
    { en:"Honest", ko:"정직한" },
    { en:"Wise", ko:"지혜로운" },
    { en:"Smart", ko:"현명한" },
    { en:"Clever", ko:"영리한" },
    { en:"Witty", ko:"재치있는" },
    { en:"Sharp", ko:"센스있는" },

    { en:"Fine", ko:"섬세한" },
    { en:"Deep", ko:"사려깊은" },
    { en:"Deep", ko:"깊은" },
    { en:"Wide", ko:"넓은" },
    { en:"Rich", ko:"풍부한" },
    { en:"Full", ko:"넉넉한" },
    { en:"Solid", ko:"든든한" },
    { en:"Fit", ko:"건강한" },
    { en:"Strong", ko:"튼튼한" },
    { en:"Tough", ko:"강인한" },

    { en:"Mystic", ko:"신비로운" },
    { en:"Dream", ko:"몽환적인" },
    { en:"Emote", ko:"감성적인" },
    { en:"Roman", ko:"낭만적인" },
    { en:"Sunny", ko:"따사로운" },
    { en:"Mild", ko:"온화한" },
    { en:"Breeze", ko:"청량한" },
    { en:"Blue", ko:"푸른" },
    { en:"Sweet", ko:"달콤한" },
    { en:"Scent", ko:"향기로운" },

    { en:"Zest", ko:"상큼한" },
    { en:"Lively", ko:"발랄한" },
    { en:"Active", ko:"활발한" },
    { en:"Brisk", ko:"경쾌한" },
    { en:"Fun", ko:"흥미로운" },
    { en:"Odd", ko:"독특한" },
    { en:"Rare", ko:"특별한" },
    { en:"Dear", ko:"소중한" },
    { en:"Noble", ko:"귀한" },
    { en:"Worth", ko:"값진" },

    { en:"Warm", ko:"정다운" },
    { en:"Close", ko:"친근한" },
    { en:"Lovely", ko:"사랑스러운" },
    { en:"Charm", ko:"매력적인" },
    { en:"Beauty", ko:"아름다운" },
    { en:"Pure", ko:"순수한" },
    { en:"Ease", ko:"여유로운" },
    { en:"Light", ko:"가벼운" },
    { en:"Solid", ko:"알찬" },
    { en:"Plenty", ko:"풍성한" },

    { en:"Fresh", ko:"신선한" },
    { en:"Clear", ko:"청명한" },
    { en:"Neat", ko:"정갈한" },
    { en:"Tidy", ko:"단정한" },
    { en:"Clean", ko:"말끔한" },
    { en:"Blend", ko:"조화로운" },
    { en:"Stable", ko:"안정적인" },
    { en:"Trust", ko:"믿음직한" },
    { en:"Even", ko:"균형잡힌" },
    { en:"Deep", ko:"깊이있는" },

    { en:"Focus", ko:"집중된" },
    { en:"Clear", ko:"명확한" },
    { en:"Bright", ko:"총명한" },
    { en:"Still", ko:"고요한" },
    { en:"Firm", ko:"단단한" },
    { en:"Solid", ko:"탄탄한" },
    { en:"Right", ko:"반듯한" },
    { en:"Grow", ko:"성장하는" },
    { en:"Learn", ko:"배우는" },
    { en:"Seek", ko:"탐구하는" }
];

const nouns = [
    { en:"Class", ko:"교실" },
    { en:"Library", ko:"도서관" },
    { en:"Lesson", ko:"수업" },
    { en:"Talk", ko:"강의" },
    { en:"Study", ko:"연구" },
    { en:"Quest", ko:"탐구" },
    { en:"Lore", ko:"지식" },
    { en:"Idea", ko:"개념" },
    { en:"Note", ko:"노트" },
    { en:"Notes", ko:"필기" },
    { en:"Review", ko:"복습" },
    { en:"Prep", ko:"예습" },
    { en:"Problem", ko:"문제" },
    { en:"Solve", ko:"풀이" },
    { en:"Idea", ko:"아이디어" },
    { en:"Mind", ko:"생각" },
    { en:"Log", ko:"기록" },
    { en:"Ask", ko:"질문" },
    { en:"Answer", ko:"답안" },
    { en:"Summary", ko:"정리" },
    { en:"Talk", ko:"발표" },
    { en:"Debate", ko:"토론" },
    { en:"Test", ko:"실험" },
    { en:"Project", ko:"프로젝트" },
    { en:"Task", ko:"과제" },
    { en:"Study", ko:"학습" },
    { en:"Read", ko:"독서" },
    { en:"Sense", ko:"이해" },
    { en:"Find", ko:"발견" },

    { en:"Cloud", ko:"구름" },
    { en:"Sunset", ko:"노을" },
    { en:"Star", ko:"별" },
    { en:"Glow", ko:"별빛" },
    { en:"Moon", ko:"달빛" },
    { en:"Sun", ko:"햇살" },
    { en:"Wind", ko:"바람" },
    { en:"Dawn", ko:"새벽" },
    { en:"Wave", ko:"파도" },
    { en:"Forest", ko:"숲" },
    { en:"Trail", ko:"숲길" },
    { en:"Flower", ko:"꽃" },
    { en:"Petal", ko:"꽃잎" },
    { en:"Grass", ko:"풀" },
    { en:"Tree", ko:"나무" },
    { en:"Leaf", ko:"잎" },
    { en:"Dew", ko:"이슬" },
    { en:"Mist", ko:"안개" },
    { en:"Sky", ko:"하늘" },
    { en:"Space", ko:"우주" },

    { en:"Book", ko:"책" },
    { en:"Pencil", ko:"연필" },
    { en:"Pen", ko:"펜" },
    { en:"Eraser", ko:"지우개" },
    { en:"Laptop", ko:"노트북" },
    { en:"Map", ko:"지도" },
    { en:"Key", ko:"열쇠" },
    { en:"Lamp", ko:"램프" },
    { en:"Candle", ko:"촛불" },
    { en:"Mirror", ko:"거울" },
    { en:"Window", ko:"창문" },
    { en:"Letter", ko:"편지" },
    { en:"Card", ko:"엽서" },
    { en:"Paper", ko:"종이" },
    { en:"Boat", ko:"종이배" },
    { en:"Balloon", ko:"풍선" },
    { en:"Ribbon", ko:"리본" },
    { en:"Button", ko:"단추" },
    { en:"Basket", ko:"바구니" },
    { en:"Cup", ko:"컵" },
    { en:"Mug", ko:"머그" },
    { en:"Clock", ko:"시계" },
    { en:"Timer", ko:"모래시계" },
    { en:"Compass", ko:"나침반" },
    { en:"Gem", ko:"보석" },
    { en:"Treasure", ko:"보물" },
    { en:"Frame", ko:"액자" },
    { en:"Palette", ko:"팔레트" },
    { en:"Canvas", ko:"캔버스" },

    { en:"Dream", ko:"꿈" },
    { en:"Hope", ko:"희망" },
    { en:"Luck", ko:"행운" },
    { en:"Miracle", ko:"기적" },
    { en:"Secret", ko:"비밀" },
    { en:"Story", ko:"이야기" },
    { en:"Quest", ko:"모험" },
    { en:"Moment", ko:"순간" },
    { en:"Time", ko:"시간" },
    { en:"Season", ko:"계절" },
    { en:"Spring", ko:"봄" },
    { en:"Summer", ko:"여름" },
    { en:"Autumn", ko:"가을" },
    { en:"Winter", ko:"겨울" },
    { en:"Rest", ko:"휴식" },
    { en:"Ease", ko:"여유" },
    { en:"Peace", ko:"평온" },
    { en:"Joy", ko:"기쁨" },
    { en:"Thrill", ko:"설렘" },
    { en:"Happy", ko:"행복" },
    { en:"Smile", ko:"미소" },
    { en:"Laugh", ko:"웃음" },
    { en:"Light", ko:"빛" },
    { en:"Color", ko:"색" },
    { en:"Melody", ko:"멜로디" },
    { en:"Rhythm", ko:"리듬" }
];

const edu = [
    "archive",
    "book2",
    "bookmark",
    "books",
    "chart",
    "clipboard",
    "cloud",
    "compass",
    "computer",
    "flower",
    "folder",
    "folder_open",
    "gear",
    "grass",
    "hammer",
    "idea",
    "lab",
    "laptop",
    "leaf",
    "microscope",
    "moon",
    "note",
    "page",
    "page2",
    "paperclip",
    "pen",
    "pencil",
    "pin",
    "pushpin",
    "ruler",
    "ruler2",
    "search",
    "search2",
    "star",
    "sun",
    "telescope",
    "testtube",
    "thinking",
    "thought",
    "tools",
    "tree",
    "wave",
    "wind",
    "wrench"
];
const nicknameMap = { adjectives, nouns, edu };

export default nicknameMap;